import React from 'react';
import style from '../../Styles/Html/ModalMessage.module.css';
import Enum  from '../../Common/Enum/Enum';
import { Button, Modal } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

const ModalMessage = ({ show, onConfirm, onCancel, menuItemName, quantity , typeOfMessage}) => {
  return (
    <Modal show={show} onHide={onCancel} centered dialogClassName={style.customModal} >
      <Modal.Header closeButton  className={(typeOfMessage === 1 ? style.headerModal  : typeOfMessage === 3 ? style.headerModalWarning : style.headerModal ) }>
        <Modal.Title> 
        {typeOfMessage === 1 ? 
           ("Enviar orden" )
         : typeOfMessage === 2 ?
           ("Agregar a la orden")
         : ("Aviso")
        }
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className={style.bodyModal}>
        {typeOfMessage === 1 ? 
          (<p> ¿Deseas crear la orden con monto : Q.{quantity} ?</p>)
        : typeOfMessage === 2 ?  
          (<p>¿Deseas agregar {quantity} {/*parseInt(quantity) > 1 ? 'unidades' : 'unidad'*/} de {menuItemName} a la orden?</p>) 
        :  
          <p> {menuItemName}</p> 
        }
      </Modal.Body>
      <Modal.Footer>
      {typeOfMessage === 3 ?
       (
        <Button variant="secondary" onClick={onCancel} className={style.cancel}>
          Ok
        </Button>
       )
      : 
       (<>
         <Button variant="secondary" onClick={onCancel} className={style.cancel}>
          No
        </Button>
        <Button variant="primary" onClick={onConfirm} className={style.confirm}>
          Sí
        </Button> </>)
      }
      </Modal.Footer>
    </Modal>
  );
};

export default ModalMessage;